import axios from "axios";
import {
  ADD_CONTRACT,
  FETCH_CONTRACTS,
  DELETE_CONTRACT,
  SHOW_CONTRACT,
  UPDATE_CONTRACT,
  DELETE_PAYMENT,
  ADD_PAYMENT,
  GET_TOTAL_CONTRACTS,
  GET_CONTRACTS_INFO,
  interceptor,
  UPDATE_PRINT_CONTRACT,
  RESEND_EMAIL,
  GET_RECENT_MEDICAL_RECORDS,
  GET_LAST_WEEK_CONTRACTS_INFO,
  GET_LAST_MONTH_CONTRACTS_INFO,
  GET_CONTRACTS_VIA_CUSTOMER_STATE,
  GET_PDF_7005_CONTRACTS_DATA,
  FETCH_CONTRACT_SHIPPERS,
  UPDATE_CONTRACT_SHIPPERS,
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function fetchContracts() {
  return {
    type: FETCH_CONTRACTS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function addContract(ctr) {
  return {
    type: ADD_CONTRACT,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/`, ctr, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getDeletable(selected) {
  const ids = { ids: selected };
  return {
    type: DELETE_CONTRACT,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/delete/`, ids, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function showContract(id) {
  return {
    type: SHOW_CONTRACT,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deletePayment(id) {
  return {
    type: DELETE_PAYMENT,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/deletePayment`, id, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateContract(id, data) {
  return {
    type: UPDATE_CONTRACT,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function addPayment(data) {
  return {
    type: ADD_PAYMENT,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/addPayment`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function getTotalContractCount() {
  return {
    type: GET_TOTAL_CONTRACTS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/getTotalContractCount`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
export function getCurrentYearContractsInfo() {
  return {
    type: GET_CONTRACTS_INFO,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/contract/getCurrentYearContractsInfo`,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function updatePrintContract(id) {
  return {
    type: UPDATE_PRINT_CONTRACT,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function resendEmail(data) {
  return {
    type: RESEND_EMAIL,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/resendEmail`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getRecentAvailableMedicalRecords(data){
  return {
    type: GET_RECENT_MEDICAL_RECORDS,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/contract/recentMedicalRecord`, data,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}


export function getLastWeekContractsInfo() {
  return {
    type: GET_LAST_WEEK_CONTRACTS_INFO,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/contract/lastWeek/contractInfo`,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function getMonthlyContractInfo(startDate) {
  return {
    type: GET_LAST_MONTH_CONTRACTS_INFO,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/contract/month/contractInfo/${startDate}`,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}


export function getContractsViaCustomerState(filterOption){
  return {
    type: GET_CONTRACTS_VIA_CUSTOMER_STATE,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/contract/viaCustomerState/${filterOption}`,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function getPdf7005RecordData(petstore_id,sdate){
  return {
    type: GET_PDF_7005_CONTRACTS_DATA,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/contract/doc/generate7005/${petstore_id}/${sdate}`,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function getContractShippers(data){
  return {
    type: FETCH_CONTRACT_SHIPPERS,
    payload: axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/core/contract/shipper/getShippers`,      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function updateContractShipper(id, data) {
  return {
    type: UPDATE_CONTRACT_SHIPPERS,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/shipper/update/contract/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}